import axios from 'axios';

import { IEmail } from '@/shared/model/email.model';

const baseApiUrl = 'api/email';

export default class EmailService {
  public send(entity: IEmail): Promise<IEmail> {
    return new Promise<IEmail>(resolve => {
      axios.post(`${baseApiUrl}/blast`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
